module.exports = __webpack_public_path__ + "img/logo-main-full-white.e5a3c759.png";